// import React from 'react';
// import HistoryItem from '../components/HIstoryItem';

// const HistoryList = () => {

//     // the values will be fetched from the database based on the userid token
//   return (
//     <div>
//       <h1 style={{ color: '#fff',padding:'20px'}}>History</h1>
//       <HistoryItem
//         title="Luis Fonsi - Despacito ft. Daddy Yankee"
//         id="RdhEjeSsMZs"
//         status="Failed"
//       />
//       {/* Add more HistoryItems as needed */}
//       <HistoryItem
//         title="Luis Fonsi - Despacito ft. Daddy Yankee"
//         id="RdhEjeSsMZs"
//         status="Failed"
//       />
//       <HistoryItem
//         title="Luis Fonsi - Despacito ft. Daddy Yankee"
//         id="RdhEjeSsMZs"
//         status="Failed"
//       />
//     </div>
      
//   );
// };

// export default HistoryList;

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HistoryItem from '../components/HIstoryItem';
import { historyfetch } from '../api';
import './History.css';
// import ReactMarkdown from 'react-markdown';



// // Function to convert ISO time to user's local time
// const convertToLocalTime = (isoTime) => {
//   const date = new Date(isoTime);
//   return date.toLocaleString(); // Converts to local date and time
// };


const HistoryList = () => {
  const [historyData, setHistoryData] = useState([]);
  // const [selectedResult, setSelectedResult] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHistory = async () => {
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const email = userInfo?.email;
      console.log("E-mail is : ", email)

      if (!email) {
        alert('Please log in to view your history.');
        navigate('/'); // Redirect to login page
        return;
      }

      try {
        const response = await historyfetch(email); 
        setHistoryData(response.data);

        if (!response.ok) {
          throw new Error('Failed to fetch history.');
        }

        // const data = await response.json();
        // setHistoryData(data); // Update state with the fetched history
      } catch (error) {
        console.error('Error fetching history:', error);
        // alert('Failed to fetch history. Please try again.');
      }
    };

    fetchHistory();
  }, [navigate]);

  const handleItemClick = (video) => {
    navigate(`/history/video/${video._id}`, { state: { video } });
  };

  // Group history data by date
  const groupedData = historyData.reduce((acc, item) => {
    if (!acc[item.date]) {
      acc[item.date] = [];
    }
    acc[item.date].push(item);
    return acc;
  }, {});


  // const handleItemClick = (result) => {
  //   setSelectedResult(result); // Set the analysis result of the clicked video
  // };

  // const closeModal = () => {
  //   setSelectedResult(null); // Clear the selected result to close the modal
  // };

  return (


    <div>
      <div className='head'>
      <button className = 'back-button' onClick={() => navigate('/')} >
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="44px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
        
      </button>
      <h1 style={{ color: '#fff' }} onClick={() => navigate('/')} >History</h1>
      </div>
      {/* <div className="history-grid">
        {historyData.map((item) => (
          <HistoryItem
            key={item._id}
            title={item.video_title}
            id={item.video_id}
            status={item.analysis_result ? 'Fetched' : 'Processing'}
            onClick={() => handleItemClick(item)}
          />
        ))}
      </div>
       */}
      <div className="history-grid">
        {historyData.length > 0 ? (
          historyData.map((item) => (
            <HistoryItem
              key={item._id}
              title={item.video_title}
              id={item.video_id}
              status={item.analysis_result ? 'Fetched' : 'Processing'}
              onClick={() => handleItemClick(item)} // Pass the result to the handler
              // onClick={() => handleItemClick(item)} // Pass the result to the handler
            />
          ))
        ) : (
          <p >No history available.</p>
        )}
      </div>


      {/* {selectedResult && (
        <div className='analysis-result'>
          <h2>Analysis Result</h2>
          <ReactMarkdown>{selectedResult}</ReactMarkdown>
        </div>
      )} */}

      {/* Modal
      {selectedResult && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>
              &times;
            </button>
            <h2>Analysis Result</h2>
            <ReactMarkdown>{selectedResult}</ReactMarkdown>
          </div>
        </div>
      )} */}
  </div>
  
  );
  // return (
  //   <div>
  //     <div className="head">
  //       <button className="back-button" onClick={() => navigate('/')}>
  //         &#x227A;
  //       </button>
  //       <h1 style={{ color: '#fff' }}>History</h1>
  //     </div>

  //     <div className="history-grid">
  //       {Object.keys(groupedData).length > 0 ? (
  //         Object.keys(groupedData).map((date) => (
  //           <div key={date} className="date-group">
  //             {/* Date Header */}
  //             <h2 className="date-header">{date}</h2>
  //             {groupedData[date].map((item) => (
  //               <div key={item._id} className="history-item">
  //                 {/* Video Details */}
  //                 <HistoryItem
  //                   title={item.video_title}
  //                   id={item.video_id}
  //                   status={item.analysis_result ? 'Fetched' : 'Processing'}
  //                   onClick={() => handleItemClick(item)}
  //                 />
  //                 {/* Display Local Time */}
  //                 <p className="time">
  //                   Time: {(item.time)}
  //                 </p>
  //               </div>
  //             ))}
  //           </div>
  //         ))
  //       ) : (
  //         <p>No history available.</p>
  //       )}
  //     </div>
  //   </div>
  // );

};

export default HistoryList;

